export default __webpack_public_path__ + "static/media/Trygg-Hansa_Logo.42c8d663.svg";